import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavDropdown } from "react-bootstrap";
import i18next from "i18next";
import { useSearchParams, useNavigate, useLocation, useParams } from "react-router-dom";
import { updateUserLanguage, isUserAuthenticated } from "../../helpers/userApi";
import { languages } from "../../constants";

import "./style.css";

export default function Language() {
  const { t, i18n } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const currentLanguageCode = i18n.language || "en";
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode);  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    const pathLang = location.pathname.split('/')[1];
    if (pathLang && languages.some(l => l.code === pathLang) && pathLang !== i18n.language) {
      i18next.changeLanguage(pathLang);
    }
  }, [location.pathname, i18n.language]);

  useEffect(() => {
    document.documentElement.dir = currentLanguage.dir || "ltr";
  }, [currentLanguage, t]);

  const handleLanguageChange = async (code) => {
    // Always change the language in the UI (i18next will handle cookie persistence automatically)
    i18next.changeLanguage(code);
    
    // Update the URL with the new language in path
    const currentPath = location.pathname;
    const pathParts = currentPath.split('/');
    if (pathParts[1] && languages.some(l => l.code === pathParts[1])) {
      pathParts[1] = code;
    } else {
      // If no lang in path, add it
      pathParts.splice(1, 0, code);
    }
    const newPath = pathParts.join('/');
    navigate(newPath + location.search);
    
    // If user is authenticated, save the preference to backend
    if (isUserAuthenticated()) {
      setIsUpdating(true);
      try {
        await updateUserLanguage(code);
        console.log(`Language preference updated to ${code}`);
      } catch (error) {
        console.error('Failed to update language preference:', error);
        // Language still changes in UI even if backend update fails
      } finally {
        setIsUpdating(false);
      }
    }
  };
  return (
    <NavDropdown 
      title={isUpdating ? `${currentLanguage.name} ⟳` : currentLanguage.name} 
      id="dropdown-basic-button"
    >
      {languages.map(({ code, name }) => (
        <NavDropdown.Item
          key={code}
          eventKey={code}
          onClick={() => handleLanguageChange(code)}
          disabled={isUpdating}
        >
          {name}
        </NavDropdown.Item>
      ))}
    </NavDropdown>

      // <img className="lang_flag" src="/assets/images/flag.png" alt="" />
      // <DropdownButton
      //   variant='outline-info'
      //   id="dropdown-basic-button"
      //   size="md"
      //   title={currentLanguage.name}
      // >
      //   {languages.map(({ code, name }) => (
      //     <Dropdown.Item
      //       key={code}
      //       onClick={() => i18next.changeLanguage(code)}
      //     >
      //       {name}
      //     </Dropdown.Item>
      //   ))}
      // </DropdownButton>
  );
}
